import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackDomainVerificationInitiated = {
  domain: string;
};

export const useTrackDomainVerificationInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackDomainVerificationInitiated = useCallback(
    (params: TrackDomainVerificationInitiated) => {
      track(`Domain verification initiated`, params);
    },
    [track],
  );

  return { trackDomainVerificationInitiated };
};
